import styled from "styled-components";

export const Container = styled.div`
  overflow-y: scroll;
  overflow-x: hidden;
  width: 100vw;
  height: 100%;
`;
export const RouteListHeader = styled.div`
  display: flex;
  justify-content: space-between;
`;
export const RouteListHeaderText = styled.div`
  font-weight: bold;
  font-size: 14px;
  padding: 6px 12px;
`;
export const ListItem = styled.a<{ isSelected: boolean }>`
  padding: 12px;
  & + & {
    border-top: 1px solid #f7f8f9;
  }
  color: #010024;
  text-decoration: none;
  display: flex;
  align-items: center;
  width: 100%;
  overflow: hidden;
  ${({ isSelected }) => (isSelected ? `background-color: #ffffce` : null)};

  &:hover {
    color: black;
  }

  & > div {
    flex-shrink: 0;
  }
  select:after {
  }
`;

export const Name = styled.div`
  flex-grow: 1;
  font-weight: bold;
`;
